<template>
  <div>
    <page-header title="Payments" breadcrumb="Billings & Payment > Payments" />
    <div class="card mt-3 p-3" style="padding:0">
      <div class="grid gap-2 grid-cols-2 w-full">
        <payments-total />
        <payments-account-payables />
      </div>
    </div>

    <div class="card table-wrapper mt-3 p-3">
     <div class="table-header">
      <div class="table__search-input-wrapper">
        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="queryString"
        />
        <search-icon />
      </div>

      <div>
          
     <select class="filter-customer">
        <option value="">--Filter By Customer--</option>
        
      </select>

      <button>Payment setup</button>
    
      </div>

    </div>
    </div>
  </div>
</template>

<script>
import PaymentsTotal from "@/components/3pl/Billings/payments-total.vue";
import PaymentsAccountPayables from "@/components/3pl/Billings/payments-account-payables.vue";
export default {
  components: {
    PaymentsTotal,
    PaymentsAccountPayables,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.table-wrapper {
  margin: 3rem 0;
  
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}
.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}
.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}
.table__search-input:focus {
  outline: none;
}
.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}
.filter-customer {
  width: 100%;
  height: 2.5rem;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  padding: 0.5rem;
  font-size: 0.9rem;
  color: #343633;
}
</style>
